import React, { useState, useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import locale from '@glu/locale';
import { Columns } from '@glu/data-components';
import { Button, PRIMARY, SECONDARY } from '@glu/buttons-react';
import { PanelWrapper } from '@glu/grid-mobile-react';
import { updateGridView } from 'logic/store/grids/actions';
import MobileGridContext from '../logic/MobileGridContext';
import * as actions from '../logic/actions';

const maxPrimaryColumns = 3;

const ColumnPanel = () => {
  const gridContext = React.useContext(MobileGridContext);
  const reduxDispatch = useDispatch();
  const columns = gridContext.columnsWithoutActions;
  const { closeDrawer, gridId } = gridContext;
  const [columnState, setColumnState] = useState(columns);

  useEffect(() => {
    setColumnState(columns);
  }, [columns]);

  const handleColumnsChange = useCallback(
    (newColumns) => {
      setColumnState(newColumns.value);
    },
    [setColumnState],
  );

  const handleClose = useCallback(() => {
    setColumnState(columns);
    closeDrawer();
  }, [columns, closeDrawer]);

  return (
    <PanelWrapper
      title={locale.get('columnsTitle')}
      footer={
        <>
          <Button
            variant={PRIMARY}
            type="button"
            text={locale.get('apply')}
            onClick={() => {
              actions.saveColumn({ gridContext, payload: { columnState } });
              // Save grid state between page navigation
              updateGridView({ gridId, columnState, dispatch: reduxDispatch });
            }}
          />
          <Button
            variant={SECONDARY}
            type="button"
            text={locale.get('cancel')}
            onClick={handleClose}
          />
        </>
      }
    >
      <Columns
        autoApplyChanges
        data={{ columns: columnState }}
        onChange={handleColumnsChange}
        darkMode={false}
        alwaysShowDragTrigger
        maxPrimary={maxPrimaryColumns}
        disablePinning
      />
    </PanelWrapper>
  );
};

export default ColumnPanel;
